import React from 'react';
import {
  FileResourceType,
  assetUpload,
} from '@uplift/api';
import { fileToBase64 } from './fileToBase64';


export const useFileUpload = (resourceType: FileResourceType, resourceName: string) => {
  const uploadFile = React.useCallback(async (file: Blob | File, name: string) => {
    const base64 = await fileToBase64(file);

    const result = await assetUpload({
      file_content: base64,
      file_name: name,
      resource_type: resourceType,
      resource_name: resourceName,
    });

    if ('error' in result) {
      throw new Error(result?.error);
    }

    return result?.id;
  }, [ resourceType, resourceName ]);

  return uploadFile;
};


export const useUploadAvatar = () => {
  return useFileUpload(FileResourceType.public, 'avatars');
};


export const useUploadInsurance = () => {
  return useFileUpload(FileResourceType.protected, 'insurance_cards');
};
